// Utility functions for auth session management

export const clearCorruptedSession = () => {
  // Clear all auth-related storage
  localStorage.removeItem('dnceclub-auth');
  sessionStorage.clear();
  
  // Clear cookies that might be holding stale sessions
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};

export const validateSession = (session: unknown): boolean => {
  if (!session) {
    return false;
  }
  
  if (typeof session !== 'object') {
    return false;
  }
  
  const s = session as Record<string, unknown>;
  
  // Check if session has required fields
  const hasAccessToken = !!s.access_token;
  const hasRefreshToken = !!s.refresh_token;
  const hasUser = !!s.user;
  
  if (!hasAccessToken || !hasRefreshToken || !hasUser) {
    return false;
  }
  
  // Check if tokens are expired
  if (s.expires_at && typeof s.expires_at === 'number') {
    const expiresAt = new Date(s.expires_at * 1000);
    const now = new Date();
    const isExpired = expiresAt < now;
    
    if (isExpired) {
      return false;
    }
  }
  
  return true;
};

export const detectSessionIssues = (): boolean => {
  try {
    const storedSession = localStorage.getItem('dnceclub-auth');
    
    if (!storedSession) {
      return true; // Missing session is an issue
    }
    
    const parsed = JSON.parse(storedSession);
    
    // Check if we have all required parts
    if (!parsed.currentSession || !parsed.currentSession.access_token) {
      return true; // Corrupted session structure
    }
    
    // Check for token expiration
    const session = parsed.currentSession;
    if (session.expires_at) {
      const expiresAt = new Date(session.expires_at * 1000);
      const now = new Date();
      if (expiresAt < now) {
        return true; // Expired session
      }
    }

    return false; // No issues detected
  } catch {
    // Error parsing session means there's an issue
    return true;
  }
};